import {urlencode} from "./text";

let lastCallbackId = 0;

const installedPackagesMapAndroid = {
  "com.facebook.orca": "facebookm",
  "com.facebook.katana": "facebook",
  "com.instagram.android": "instagram",
  "com.whatsapp": "whatsapp",
  "org.telegram.messenger": "telegram",
  "com.snapchat.android": "snapchat",
  "com.zhiliaoapp.musically": "tiktok",
};

const installedPackagesMapIos = {
  "fb-messenger://": "facebookm",
  "fb://": "facebook",
  "instagram://": "instagram",
  "whatsapp://": "whatsapp",
  "telegram://": "telegram",
  "snapchat://": "snapchat",
  "tiktoksharesdk://": "tiktok",
};

function createWebviewCallbackFunc(cb) {
  const funcName = "webviewFuncCallback_" + lastCallbackId;
  lastCallbackId++;

  window[funcName] = function() {
    if (cb) {
      cb(...arguments);
    }

    delete window[funcName];
  };

  return funcName;
}

export function webviewBuildCallURL(func, params) {
  const queryPairs = [];

  Object.keys(params).forEach((key) => {
    if (typeof params[key] !== "undefined") {
      queryPairs.push(`${key}=${params[key]}`);
    }
  });

  return `callback:${func}?${queryPairs.join("&")}`;
}

export function webviewCall(func, params) {
  const cbs = webviewBuildCallURL(func, params);

  console.log("WEBVIEW CALLBACK: " + cbs);
  window.location.href = cbs;
}

export function webviewCallWithCallback(func, params, cb) {
  params.func = createWebviewCallbackFunc(cb);

  webviewCall(func, params);
}

// ---

export function webviewOpenBrowser(url) {
  webviewCall("openblank", {url: urlencode(url)});
}

export function webviewPreloadAd() {
  webviewCall("preloadAd", {});
}

export function webviewShowAd(adShownCb, adClosedCb) {
  webviewCall("showAd", {
    adShown: createWebviewCallbackFunc(adShownCb),
    adClosed: createWebviewCallbackFunc(adClosedCb),
  });
}

export function webviewShowNativeAds() {
  webviewCall("showNativeAds", {
    func: "webview_native_ad_shown",
  });
}

export function webviewHideNativeAds() {
  webviewCall("hideNativeAds", {});
}

// ---

export function webviewRateApp(func) {
  webviewCallWithCallback("rateApp", func);
}

// ---

export function webviewShare(params, cb) {
  webviewCallWithCallback("nativeShare", params, cb);
}

export function webviewShareFacebook(url, imageUrl, hashtag, options, cb) {
  const params = {
    providers: "[2]",
    hashtag: encodeURIComponent(hashtag),
    no_sound: 1,
  };

  if (url) {
    params.url = encodeURIComponent(url);
  }

  if (imageUrl) {
    params.imageUrl = encodeURIComponent(imageUrl);
  }

  webviewShare(Object.assign(params, options || {}), cb);
}

export function webviewShareInstagramStory(url, imageUrl, options, cb) {
  const params = Object.assign({
    providers: "[1]",
    url: encodeURIComponent(url),
    imageUrl: encodeURIComponent(imageUrl),
    ig_direct: 1,
    ig_share_to: 'stories',
    close_after_share: 1,
    no_sound: 1,
  }, options || {});

  webviewShare(params, cb);
}

export function webviewShareInstagramFeed(url, imageUrl, options, cb) {
  const params = Object.assign({
    providers: "[1]",
    url: encodeURIComponent(url),
    imageUrl: encodeURIComponent(imageUrl),
    ig_direct: 1,
    ig_share_to: 'feed',
    close_after_share: 1,
    no_sound: 1,
  }, options || {});

  webviewShare(params, cb);
}

export function webviewShareSnapchatImage(attachmentUrl, imageUrl, options, cb) {
  const params = Object.assign({
    providers: "[11]",
    imageUrl: encodeURIComponent(imageUrl),
    caption_text: "",
  }, options || {});

  if (attachmentUrl) {
    params.attachment_url = encodeURIComponent(attachmentUrl);
  }

  webviewShare(params, cb);
}

export function webviewShareDownload(imageUrl, cb) {
  const params = {
    providers: "[0]",
    imageUrl: encodeURIComponent(imageUrl)
  };

  webviewShare(params, cb);
}

// ---

export function webviewCheckInstalledApps(cb) {
  if (window.clientConfig.isWebviewIOS) {
    webviewCheckInstalledAppsIos(cb);
  } else {
    webviewCheckInstalledAppsAndroid(cb);
  }
}

function webviewCheckInstalledAppsIos(cb) {
  const packages = Object.keys(installedPackagesMapIos)
    .map((item) => encodeURIComponent(item))
    .join(",");

  webviewCallWithCallback("nativeInstalledApps", {packages: `[${packages}]`}, function(result) {
    result = JSON.parse(result);

    const installedApps = {};
    Object.keys(result.packages).forEach((key) => {
      installedApps[installedPackagesMapIos[key]] = result.packages[key] === 1;
    });

    cb(installedApps);
  });
}

function webviewCheckInstalledAppsAndroid(cb) {
  const packages = Object.keys(installedPackagesMapAndroid).join(",");

  webviewCallWithCallback("nativeInstalledApps", {packages: `[${packages}]`}, function(result) {
    const installedApps = {};
    Object.keys(result.packages).forEach((key) => {
      installedApps[installedPackagesMapAndroid[key]] = result.packages[key] === 1;
    });

    cb(installedApps);
  });
}

export function getWebviewInputFilesFromURL(inputURL) {
  const url = new URL(inputURL || window.location.href);
  const files = [];

  for (let i = 0; i < 10; i++) {
    if (!url.searchParams.has(`url[${i}]`)) {
      break;
    }

    const fileUrl = url.searchParams.get(`url[${i}]`);
    if (!fileUrl) {
      break;
    }

    files.push({
      url: decodeURIComponent(fileUrl),
      rect: url.searchParams.get(`rect[${i}]`) || "",
      rotation: parseInt(url.searchParams.get(`rotation[${i}]`)) || 0,
      flip: parseInt(url.searchParams.get(`flip[${i}]`)) || 0,
    });
  }

  return files;
}
